import { createTopic } from '../lib';
import { z } from 'zod';

const extensionManagerNavigatedEventSchema = z.object({
  path: z
    .string()
    .describe('The navigated path in the extension manager page.'),
});

export type ExtensionManagerNavigatedEvent = z.infer<
  typeof extensionManagerNavigatedEventSchema
>;

export const extensionManagerNavigatedTopic =
  createTopic<ExtensionManagerNavigatedEvent>(
    {
      namespace: 'settings',
      name: 'extension-manager-navigated',
      description: 'Extension manager has been navigated',
    },
    extensionManagerNavigatedEventSchema,
  );
